import React, {useCallback, useContext} from 'react';

import {MessageContext} from 'src/contexts/message-context';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';


import {RemoveSearchModal} from './remove-search.modal';
import {useRemoveSearch} from './useRemoveSearch';

type Props = {
    sectionId: number,
    searchName: string,
    onRemove: () => void,
};

export const RemoveSearch = ({onRemove, sectionId, searchName}: Props) => {
    const {onClick, onClose, shown} = useShown();
    const {setSuccessMessage} = useContext(MessageContext);

    const {busy, event} = useRemoveSearch({onSuccess: () => {
        onRemove();
        onClose();
        setSuccessMessage('Search deleted successfully');
    }});

    const removeSearch = useCallback(() => {
        event(sectionId);
    }, [sectionId, event]);

    return (
        <>
            <FlatButton onClick={onClick}><b>Delete</b></FlatButton>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 600}}}>
                <RemoveSearchModal
                    busy={busy}
                    searchName={searchName}
                    onRemove={removeSearch}
                    onClose={onClose}
                />
            </Dialog>
        </>
    );
};
